import { Button } from '@chakra-ui/react';
import { getUsefulVars } from '../../../handlers/helpers';
import { onLink } from '../../../handlers';

const MenuLink = ({props,sectionName,updated,buttonStyles}) => {
  const uv = getUsefulVars(props);
  if (updated) {
    return (

      <Button marginLeft='2rem'
        sx={{ ...buttonStyles.update }}
        onClick={() => onLink(false, uv.formikProps, uv.stateProps, sectionName, 0, 'section', uv.resumeIndex, props)}>
        See Results
      </Button>
    );
  } else {
    return (
      <Button marginLeft='2rem'
        sx={{ ...buttonStyles.tertiary, ...buttonStyles.start }}
        onClick={() => onLink(false, uv.formikProps, uv.stateProps, sectionName, 0, 'section', uv.resumeIndex, props)}>
        Start
      </Button>

    );
  }
}
export default MenuLink;